import { render, staticRenderFns } from "./liveChat.vue?vue&type=template&id=66f574a4&"
import script from "./liveChat.vue?vue&type=script&lang=ts&"
export * from "./liveChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports